// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1Xbrn","requiredAsterisk":"Info_requiredAsterisk__1BCto"};